/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ParticipantPatchRole } from './participantPatchRole';

export interface ParticipantPatch {
  role?: ParticipantPatchRole;
  display_name?: string | null;
  claim_interviewer?: boolean | null;
}
